import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, Route, Router, RouterStateSnapshot, UrlSegment} from "@angular/router";
import {AuthService} from "@Services/auth";
import {HelperIndividuService} from "app/archivage/common/services/helper-individu/helper-individu.service";


function canDo(enabled: boolean, router: Router) {
  if (enabled) {
    return true;
  } else {
    router.navigateByUrl('/forbidden');
    return false;
  }
}


@Injectable({
  providedIn: 'root'
})
export class AuthenticatedGuardService {
  constructor(private router: Router, private authService: AuthService) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    return canDo(this.authService.isAuthenticated(), this.router);
  }

  canLoad(route: Route, segments: UrlSegment[]): boolean {
    return canDo(this.authService.isAuthenticated(), this.router);
  }
}

@Injectable({
  providedIn: 'root'
})
export class GestionnaireGuardService {
  constructor(private router: Router, private helperIndividuService: HelperIndividuService) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    return canDo(this.helperIndividuService.isGestionnaire, this.router);
  }

  canLoad(route: Route, segments: UrlSegment[]): boolean {
    return canDo(this.helperIndividuService.isGestionnaire, this.router);
  }
}

@Injectable({
  providedIn: 'root'
})
export class SuperviseurGuardService {
  constructor(private router: Router, private helperIndividuService: HelperIndividuService,) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    return canDo(this.helperIndividuService.isSuperviseur, this.router);
  }

  canLoad(route: Route, segments: UrlSegment[]): boolean {
    return canDo(this.helperIndividuService.isSuperviseur, this.router);
  }
}

@Injectable({
  providedIn: 'root'
})
export class NoBodyGuardService {
  constructor(private router: Router, private helperIndividuService: HelperIndividuService,) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    return false;
  }

  canLoad(route: Route, segments: UrlSegment[]): boolean {
    return false;
  }
}
